import { createAsyncThunk } from '@reduxjs/toolkit';
import Cookies from 'js-cookie';
import axios from '../../axios';

export const register = createAsyncThunk(
    'auth/register',
    async ({ username, walletAddress, isCivic, password, email, telegramUsername }, { rejectWithValue }) => {
        try {
            await axios.post('/api/auth/register', { username, walletAddress, isCivic, password, email, telegramUsername });
            const response = await axios.get('/api/users/me');
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response.data);
        }
    }
);

export const login = createAsyncThunk(
    'auth/login',
    async ({ username, password }, { rejectWithValue }) => {
        try {
            await axios.post('/api/auth/login', { username, password });
            const response = await axios.get('/api/users/me');
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response.data);
        }
    }
);

export const updateUser = createAsyncThunk(
    'auth/updateUser',
    async ({ username, password, email, telegramUsername }, { rejectWithValue }) => {
        try {
            await axios.post('/api/auth/update', { username, password, email, telegramUsername });
            const response = await axios.get('/api/users/me');
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response.data);
        }
    }
);

export const update = createAsyncThunk(
    'auth/update',
    async ({ isCivicId }, { rejectWithValue }) => {
        try {
            await axios.post('/api/users/update', { isCivicId });
            const response = await axios.get('/api/users/me');
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response.data);
        }
    }
);

export const me = createAsyncThunk(
    'auth/me',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get('/api/users/me');
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response.data);
        }
    }
);

export const profile = createAsyncThunk(
    'auth/profile',
    async ({ username }, { rejectWithValue }) => {
        try {
            const response = await axios.post('/api/users/profile', { username });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const clear = createAsyncThunk('auth/logout', async (_, { rejectWithValue }) => {
    try {
        const response = await axios.post('/api/auth/logout');
        Cookies.remove('token');
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response.data);
    }
});
